const c = {
  name: "XcodeOs",
  dimensions: { width: 32, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 32 40" style="enable-background:new 0 0 32 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M31.8,5.8c-0.3-0.7-0.9-1.3-1.6-1.6l-1.8-0.8l-0.4,0.9c-0.2,0.5-0.8,0.8-1.3,0.5l-0.1-0.1
			c0-0.4-0.1-0.9-0.2-1.3c-0.3-0.7-0.9-1.3-1.6-1.6l-3.7-1.5c-1.2-0.5-2.6-0.5-3.8,0C16.2,0.7,15.6,1.3,15,2H5C2.2,2,0,4.3,0,7v14
			c0,2.8,2.2,5,5,5h6.5c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.1,0.3c0.6,1.1,1.8,1.8,3,1.8c0.3,0,0.6,0,1-0.1c1-0.3,1.8-1,2.2-2H19
			c2.8,0,5-2.2,5-5v-9.8l0.7-1.7c0.2,0.1,0.4,0.3,0.5,0.5c0.1,0.2,0.1,0.5,0,0.8l-0.4,0.9l1.8,0.8c0.4,0.1,0.8,0.2,1.1,0.2
			s0.8-0.1,1.2-0.2c0.7-0.3,1.3-0.9,1.6-1.6l1.1-2.8C32.1,7.4,32.1,6.6,31.8,5.8L31.8,5.8z M2,21V7c0-1.7,1.3-3,3-3h9l0.9,0.4
			c1.4,0.6,2.5,1.5,2.9,2.5C18,7.2,18,7.5,17.9,7.8l-0.4,0.9l0.9,0.4l-3.1,6.5l-2-3.1l3.1-4.9l-1.7-1.1L12,10.6L9.3,6.5L7.7,7.5
			l3.1,4.9L8.5,16H6v2h1.2l-1.6,2.5l1.7,1.1L9.6,18H14l-2.5,5.2c-0.1,0.2-0.2,0.5-0.3,0.8H5C3.3,24,2,22.6,2,21L2,21z M10.9,16
			l1.1-1.7l1.1,1.7H10.9z M16,25.2c-0.1,0.4-0.5,0.8-0.9,0.9c-0.6,0.2-1.3-0.1-1.7-0.7c-0.2-0.4-0.2-0.9,0-1.3l6.9-14.3l1,0.4
			L16,25.2L16,25.2z M19,24h-0.5l3.5-9.9V21C22,22.7,20.6,24,19,24z M29.9,7.4l-1.1,2.8c-0.1,0.2-0.3,0.4-0.5,0.5
			c-0.2,0.1-0.5,0.1-0.8,0l-0.1-0.1c0-0.4-0.1-0.9-0.2-1.3c-0.3-0.7-0.9-1.3-1.6-1.6l-1.8-0.8l-0.8,1.8l-2.7-1.1l-0.3-0.1
			c0-0.5-0.1-1-0.3-1.5c-0.5-1.2-1.5-2.2-2.9-3c0.3-0.3,0.7-0.6,1.1-0.8c0.8-0.3,1.6-0.3,2.3,0l3.7,1.5c0.2,0.1,0.4,0.3,0.5,0.5
			c0.1,0.2,0.1,0.5,0,0.8L24,6l1.9,0.8c1.2,0.5,2.5,0.2,3.4-0.8L29.4,6c0.2,0.1,0.4,0.3,0.5,0.5C30,6.8,30,7.1,29.9,7.4L29.9,7.4z"
			/>
		<path class="st0" d="M8,30c-1.7,0-3,1.4-3,3v4c0,1.7,1.3,3,3,3s3-1.3,3-3v-4C11,31.4,9.7,30,8,30z M9,37c0,0.6-0.5,1-1,1
			c-0.6,0-1-0.4-1-1v-4c0-0.5,0.4-1,1-1c0.5,0,1,0.5,1,1V37z"/>
		<path class="st0" d="M17,33c0-0.5-0.5-1-1-1c-0.6,0-1,0.5-1,1c0,0.6,0.4,1,1,1c1.6,0,3,1.4,3,3c0,1.7-1.4,3-3,3c-1.7,0-3-1.3-3-3
			h2c0,0.6,0.4,1,1,1c0.5,0,1-0.4,1-1c0-0.5-0.5-1-1-1c-1.7,0-3-1.3-3-3c0-1.6,1.4-3,3-3c1.6,0,3,1.4,3,3H17z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as XcodeOs
};
